import { usePostLayoutSize } from '../../utils/responsive/PostLayoutSizeProvider';

const useIsPostTopicBarLarge = () => {
  const postLayoutSize = usePostLayoutSize();
  return postLayoutSize !== 'mobile';
};

export default useIsPostTopicBarLarge;
